/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// react-quill components
import ReactQuill from "assets/js/react-quill-with-table";

import { useRef } from 'react';

// react-quill styles
import "assets/css/quill.snow.css";

// Custom styles for the SuiEditor
import SuiEditorRoot from "components/SuiEditor/SuiEditorRoot";

function SuiEditor(props) {
  const ref = useRef();

  return (
    <SuiEditorRoot>
      <ReactQuill theme="snow" ref={ref} {...props}
        modules={
          {
            toolbar: {
              container: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "link"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["table", "clean"],
              ],
            },
          }
        }
      />
    </SuiEditorRoot>
  );
}

export default SuiEditor;
